import Vue from 'vue';
import _ from 'lodash';

/* eslint-disable */
export default {
  updateQueryParams: (state, queryParams) => state.queryParams = queryParams,
  updateTranscoderEnvironment: (state, transcoderEnvironment) => state.transcoderEnvironment = transcoderEnvironment,
  updateQueryString: (state, queryString) => state.queryString = queryString,
  updateHostingLog: (state, hostingLog) => state.hostingLog = hostingLog,
  updateToken: (state, token) => state.token = token,
  updateCardTab: (state, cardTab) => state.cardTab = cardTab,
  updateTeacherId: (state, teacherId) => state.teacherId = parseInt(teacherId),
  updateBulbId: (state, bulbId) => state.bulbId = parseInt(bulbId),
  updateInteractionId: (state, interactionId) => state.interactionId = parseInt(interactionId),
  updateLessonId: (state, lessonId) => state.lessonId = parseInt(lessonId),
  updateBulbAttemptId: (state, bulbAttemptId) => state.bulbAttemptId = parseInt(bulbAttemptId),
  updateQuestionId: (state, questionId) => state.questionId = parseInt(questionId),
  updateUserAgent: (state, userAgent) => state.userAgent = userAgent,
  updateKeyboardFocus: (state, keyboardFocus) => state.keyboardFocus = keyboardFocus,
  updateTranscoderSize: (state, transcoderSize) => state.transcoderSize = transcoderSize,
  toggleLoading: (state, loadings) => {
    if (Array.isArray(loadings) && loadings.length) {
      loadings.forEach((l, i) => {
        l.status = (i === 0);
        l.error = '';
        if (!l.cancel) l.cancel = null;
        l.progress = 0;
        l.key = i;
      });
      Vue.set(state.loading, 'loadings', loadings);
    } else {
      Vue.set(state.loading, 'loadings', []);
    }
  },
  updateLoadingByIndex: (state, load) => {
    if (!_.isArray(load)) load = [load];
    if (!state.loading.loadings || !state.loading.loadings.length) return false;
    load.forEach((l) => {
      const clone = _.cloneDeep(state.loading.loadings[l.index]);
      Object.keys(clone).forEach((key) => {
        if (_.has(clone, key) && _.has(l, key)) {
          if (key === 'progress' && l[key] > 100) l[key] = 100;
          Vue.set(clone, key, l[key]);
        }
      });
      Vue.set(state.loading.loadings, l.index, clone);
    });
  },
};